import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripViewDashboardComponent } from './components/trip-view-dashboard/trip-view-dashboard.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { TripInfoCardComponent } from './components/cards/trip-info-card/trip-info-card.component';
import { AttendanceComponent } from './components/cards/attendance/attendance.component';
import { BusStopCardComponent } from './components/cards/bus-stop-card/bus-stop-card.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EmployeeCardComponent } from './components/cards/employee-card/employee-card.component';
import { DeviceHealthComponent } from './components/device-health/device-health.component';
import {
  ModalModule as MisModalModule,
  ModalModule,
} from 'mis-crystal-design-system/modal';
import { SwitchModule } from 'mis-crystal-design-system/switch';
import { EmployeesDetailsComponent } from './components/employees-details/employees-details.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownModule } from 'mis-crystal-design-system/dropdown';
import { DatepickerModuleV2 } from 'mis-crystal-design-system/datepicker_v2';
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { ToolTipModule } from 'mis-crystal-design-system/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmployeeListComponent } from './components/employee-list/employee-list.component';
import { RadioButtonModule } from 'mis-crystal-design-system/radio-button';
import { MultiSelectDropdownModule } from 'mis-crystal-design-system/multi-select-dropdown';
import { MatTableModule } from '@angular/material/table';
import { TabFilterComponent } from '../trip-view-cab/components/map-view/tab-filter/tab-filter.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'src/shared/shared.module';
@NgModule({
  declarations: [
    TripViewDashboardComponent,
    MapViewComponent,
    SideBarComponent,
    TripInfoCardComponent,
    AttendanceComponent,
    BusStopCardComponent,
    EmployeeCardComponent,
    DeviceHealthComponent,
    EmployeesDetailsComponent,
    EmployeeListComponent,
  ],
  imports: [
    LoaderModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule,
    ModalModule,
    BrowserAnimationsModule,
    SwitchModule,
    MatDialogModule,
    DatepickerModuleV2,
    DropdownModule,
    RadioButtonModule,
    ReactiveFormsModule,
    ToolTipModule.forRoot(),
    MultiSelectDropdownModule.forRoot(),
    MatTableModule,
    MatTooltipModule,
    TabFilterComponent,
    SharedModule
  ],
  exports: [SideBarComponent, TripInfoCardComponent, AttendanceComponent],
})
export class TripViewModule {}
